<template>
    <input type="text"
           :name="name"
           :id="id"
           :placeholder="placeholder"
           readonly>
</template>

<script>
    import moment from 'moment';
    import pickerLegacy from '../../../../../../node_modules/pickadate/lib/legacy.js'
    import pickerBase from '../../../../../../node_modules/pickadate/lib/picker.js'
    import datePicker from '../../../../../../node_modules/pickadate/lib/picker.date.js'
    //not sure if wee need this or not 
    //require('../../../../../node_modules/pickadate/lib/compressed/themes/classic.css')
    //require('../../../../../node_modules/pickadate/lib/compressed/themes/classic.date.css')

    export default {
        name: 'VueDatePicker',
        model: {
            prop: 'selectedMoment',
            event: 'changed'
        },
        props: {
            id: {
                type: String,
                required: true
            },
            name: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            selectedMoment: {
                type: String,
                default: null
            }
        },
        mounted() {
            //init picker
            $(this.$el).pickadate({
                min: true,
                format: 'd mmm, yyyy',
                onSet: (context) => {
                    if (context.select)
                        this.onDateSelected(moment(context.select));
                    else
                        this.onDateSelected(null);
                }
            });

            //set its value
            if (this.selectedMoment)
                this.setPickerValue();
        },
        watch: {
            selectedMoment: function(newVal, oldVal){
                console.log(newVal, oldVal);
                if(newVal != oldVal) {
                    this.setPickerValue();
                }
            }
        },
        methods: {
            setPickerValue: function () {
                var picker = $(this.$el).pickadate("picker");
                var currentValue = picker.get('select');
                if (currentValue && this.selectedMoment) {
                    var currentDate = moment(currentValue.pick).format("DD-MM-YYYY");
                    if (currentDate === this.selectedMoment)
                        return;
                }

                if(this.selectedMoment) {
                    var date = moment(this.selectedMoment, "DD-MM-YYYY");
                    picker.set('select', date.toDate());
                }
                else {
                    picker.set('clear');
                }
            },
            onDateSelected(newValue) {
                if (newValue) {
                    var formattedValue = newValue.format("DD-MM-YYYY");
                    this.$emit("changed", formattedValue);
                } else {
                    this.$emit("changed", null);
                }
            }
        }
    }
</script>